var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { PostLoad } from "../services/postLoad";
import { executeDelayedReport } from "./delayedReport/delayedReport";
import { Cart } from "../services/cart";
import { Report } from "../services/reporting";
import getSessionToken from "../utils/getSessionToken";
import { Autocomplete, CATEGORY_FROM_AUTOCOMPLETE, hasSvelteAutocompleteDelayedReport, POPULAR_SEARCH_FROM_AUTOCOMPLETE, PRODUCT_FROM_AUTOCOMPLETE, } from "./autocomplete/autocomplete";
import navigate from "./navigate/navigate";
import jqueryPageReport, { hasJqueryPageReport } from "../utils/jqueryPageReport";
import getUserSession, { setUserSession } from "../utils/getUserSession";
import { hasSvelteSERPDelayedReport, PRODUCT_FROM_CATEGORY, PRODUCT_FROM_LANDING_PAGE, PRODUCT_FROM_SEARCH, Serp } from "./serp/serp";
import reportThankYou, { isThankYou } from "../services/thankYou";
import intervalUntil from "../utils/intervalUntil";
import { hasSvelteRecommendationsDelayedReport, PRODUCT_FROM_RECOMMENDATIONS, Recommendations, PRODUCT_CLICKED_FROM_RECOMMENDATIONS } from "./recommendations/recommendations";
import { getProductPageID, isCartPage } from "@fast-simon/common";
import { setUserLocation } from "../utils/getUserLocation";
import setServingSegments from "../utils/setServingSegments";
import { setUserVariation } from "../utils/ABTesting";
export class FastSimonReporting {
    constructor({ uuid, storeID, platform }) {
        this.uuid = uuid;
        this.storeID = storeID;
        this.cartToken = undefined;
        this.userSession = "";
        this.sessionToken = { lastActive: 0, start: 0 };
        this.platform = platform;
        this.userLocation = undefined;
        this.ispSegmentsServing = false;
    }
    setSession() {
        return __awaiter(this, void 0, void 0, function* () {
            const userSession = getUserSession();
            const data = yield PostLoad({
                uuid: this.uuid,
                storeID: this.storeID,
                userSession: userSession,
                sessionToken: this.sessionToken,
                cartToken: this.cartToken
            });
            this.userSession = data.isp_token;
            setUserSession(this.userSession);
            setUserVariation(data === null || data === void 0 ? void 0 : data.variation_id);
            if (data === null || data === void 0 ? void 0 : data.location) {
                this.userLocation = data.location;
                setUserLocation(this.userLocation, this.uuid);
            }
            else {
                setUserLocation(undefined, this.uuid);
            }
            this.ispSegmentsServing = (data === null || data === void 0 ? void 0 : data.isp_segments_serving) || false;
            setServingSegments(this.ispSegmentsServing);
            return true;
        });
    }
    setCartToken() {
        this.cartToken = Cart.getToken(this.platform);
        if (this.cartToken) {
            Cart.saveToken(this.cartToken, this.platform);
        }
        return true;
    }
    setSessionToken() {
        this.sessionToken = getSessionToken();
        return true;
    }
    ;
    executeSelfReporting() {
        const base = this.getBase();
        const platform = this.platform;
        // care viewed
        if (isCartPage(platform)) {
            Cart.report(base);
        }
        // direct product view
        const id = getProductPageID(platform);
        if (!hasJqueryPageReport()
            && !hasSvelteSERPDelayedReport()
            && !hasSvelteAutocompleteDelayedReport()
            && !hasSvelteRecommendationsDelayedReport()
            && id) {
            // report product from direct
            Report(Object.assign(Object.assign({}, base), { params: {
                    id: id,
                } }));
        }
    }
    getBase() {
        var _a, _b;
        return {
            uuid: this.uuid,
            storeID: this.storeID,
            platform: this.platform,
            userSession: this.userSession,
            sessionToken: this.sessionToken,
            cartToken: (_b = (_a = this.cartToken) !== null && _a !== void 0 ? _a : Cart.getToken(this.platform)) !== null && _b !== void 0 ? _b : "",
            segments: this.ispSegmentsServing
        };
    }
    runBackgroundTasks() {
        return __awaiter(this, void 0, void 0, function* () {
            /* 1. setup session token using locals storage or calculate it*/
            this.setSessionToken();
            /* 2. setup cart token */
            this.setCartToken();
            if (!this.cartToken) {
                yield intervalUntil({
                    stopCondition: () => Boolean(this.cartToken),
                    timeout: 333,
                    callback: () => this.setCartToken(),
                    retries: 5
                });
            }
            /* 3. setup user session using API */
            yield this.setSession();
            /* 4. execute reports - cart visited and direct product view */
            this.executeSelfReporting();
            /* 5. execute reports - delayed reports from serp and autocomplete */
            executeDelayedReport(PRODUCT_FROM_CATEGORY);
            executeDelayedReport(PRODUCT_FROM_SEARCH);
            executeDelayedReport(PRODUCT_FROM_AUTOCOMPLETE);
            executeDelayedReport(PRODUCT_FROM_RECOMMENDATIONS);
            executeDelayedReport(CATEGORY_FROM_AUTOCOMPLETE);
            executeDelayedReport(POPULAR_SEARCH_FROM_AUTOCOMPLETE);
            executeDelayedReport(PRODUCT_CLICKED_FROM_RECOMMENDATIONS);
            executeDelayedReport(PRODUCT_FROM_LANDING_PAGE);
            /* 6. execute jquery serp report*/
            jqueryPageReport(this.platform, this.getBase());
            /* 7. execute thank you report */
            if (isThankYou()) {
                reportThankYou({
                    sessionToken: this.sessionToken,
                    cartToken: this.cartToken
                });
            }
        });
    }
    initialize() {
        this.runBackgroundTasks().then(() => {
            console.log("Fast Simon Reporting: background task completed");
        }).catch(e => {
            console.error(e);
        });
        return {
            Autocomplete: Autocomplete(() => this.getBase()),
            Serp: Serp(() => this.getBase()),
            Recommendations: Recommendations(() => this.getBase()),
            navigate,
            refreshCartToken: () => this.setCartToken(),
            isReady: () => Boolean(this.sessionToken && this.userSession),
            getBase: () => this.getBase(),
        };
    }
}
//# sourceMappingURL=FastSimonReporting.js.map